export default "__VITE_ASSET__suUqIZOI__"